import { Cell, Flow, Text } from 'bold-ui'
import { RastreioCancerPerguntaDbEnum } from 'graphql/types.generated'

interface CitopatologicoGrupoDadosColetaProps {
  titulo: string
  itens: RastreioCancerPerguntaDbEnum[]
  has: (key: RastreioCancerPerguntaDbEnum) => boolean
  get: (key: RastreioCancerPerguntaDbEnum) => string | undefined
  label: (key: RastreioCancerPerguntaDbEnum) => string | undefined
}

export function CitopatologicoGrupoDadosColeta(props: Readonly<CitopatologicoGrupoDadosColetaProps>) {
  const { titulo, itens, has, get, label } = props

  if (!itens.some(has)) return null

  return (
    <Cell size={6}>
      <Flow direction='vertical' gap={0}>
        <Text fontWeight='bold'>{titulo}</Text>
        {itens.map(
          (key) =>
            has(key) && (
              <Text key={key}>
                <Text fontWeight='bold'>{label(key)}</Text>
                {` `}
                {get(key)}
              </Text>
            )
        )}
      </Flow>
    </Cell>
  )
}
